// src/pages/SuperAdminRegister.jsx
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/SuperAdminRegister.css';

const SuperAdminRegister = () => {
    const [pendingRequests, setPendingRequests] = useState([]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const token = localStorage.getItem('token');

    const fetchPendingRequests = useCallback(async () => {
        setLoading(true);
        setError('');
        setMessage('');
        try {
            // URL sudah diubah ke HTTPS dan '/api/admin/'
            const response = await axios.get('https://depotaircerdas.com/api/admin/pending-registrations', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (Array.isArray(response.data)) {
                setPendingRequests(response.data);
            } else {
                console.error("API response for pending requests was not an array:", response.data);
                setError("Format data yang diterima tidak sesuai. Harap hubungi administrator.");
                setPendingRequests([]);
            }
        } catch (err) {
            console.error("Error fetching pending requests:", err);
            const errorMessage = err.response?.data?.message || "Gagal mengambil daftar permintaan registrasi.";
            setError(errorMessage);

            if (err.response?.status === 403 || err.response?.status === 401) {
                alert(errorMessage + " Anda akan diarahkan ke halaman login.");
                localStorage.removeItem('token');
                localStorage.removeItem('username');
                localStorage.removeItem('is_super_admin');
                navigate('/login', { replace: true });
            }
        } finally {
            setLoading(false);
        }
    }, [token, navigate]);

    useEffect(() => {
        if (!token) {
            navigate('/login', { replace: true });
            return;
        }
        const isSuperAdmin = localStorage.getItem('is_super_admin') === 'true';
        if (!isSuperAdmin) {
            alert('Akses ditolak. Anda bukan Super Admin.');
            navigate('/dashboard', { replace: true });
            return;
        }

        fetchPendingRequests();
    }, [token, navigate, fetchPendingRequests]);

    const handleApprove = async (id) => {
        if (window.confirm("Apakah Anda yakin ingin MENYETUJUI permintaan ini?")) {
            setLoading(true);
            setError('');
            setMessage('');
            try {
                const response = await axios.post(`https://depotaircerdas.com/api/admin/approve-registration/${id}`, {}, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMessage(response.data.message);
                fetchPendingRequests();
            } catch (err) {
                console.error("Error approving request:", err);
                const errorMessage = err.response?.data?.message || "Gagal menyetujui permintaan.";
                setError(errorMessage);
                if (err.response?.status === 403 || err.response?.status === 401) {
                    alert(errorMessage + " Anda akan diarahkan ke halaman login.");
                    localStorage.removeItem('token');
                    localStorage.removeItem('username');
                    localStorage.removeItem('is_super_admin');
                    navigate('/login', { replace: true });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const handleReject = async (id) => {
        if (window.confirm("Apakah Anda yakin ingin MENOLAK permintaan ini? Data akan dihapus permanen.")) {
            setLoading(true);
            setError('');
            setMessage('');
            try {
                const response = await axios.delete(`https://depotaircerdas.com/api/admin/reject-registration/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMessage(response.data.message);
                fetchPendingRequests();
            } catch (err) {
                console.error("Error rejecting request:", err);
                const errorMessage = err.response?.data?.message || "Gagal menolak permintaan.";
                setError(errorMessage);
                if (err.response?.status === 403 || err.response?.status === 401) {
                    alert(errorMessage + " Anda akan diarahkan ke halaman login.");
                    localStorage.removeItem('token');
                    localStorage.removeItem('username');
                    localStorage.removeItem('is_super_admin');
                    navigate('/login', { replace: true });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="admin-panel-container">
            <h2>Panel Super Admin - Permintaan Registrasi</h2>
            <button onClick={fetchPendingRequests} disabled={loading} style={{ marginBottom: '20px', padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                {loading ? 'Memuat...' : 'Refresh Permintaan'}
            </button>
            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}

            {loading && <p>Memuat permintaan...</p>}
            {!loading && (
                pendingRequests.length === 0 ? (
                    <p>Tidak ada permintaan registrasi yang tertunda.</p>
                ) : (
                    <div className="requests-list">
                        {pendingRequests.map(req => (
                            <div key={req.id} className="request-card">
                                <h3>Permintaan dari: {req.username}</h3>
                                <p><strong>Nama Depot:</strong> {req.depot_name}</p>
                                <p><strong>Alamat:</strong> {req.address}</p>
                                <p><strong>Info Tangki:</strong> {req.tank_name} ({req.capacity}L, {req.height_cm}cm)</p>

                                <h4>Sensor Utama:</h4>
                                {req.sensors && Array.isArray(req.sensors) && req.sensors.filter(s => s.is_main).map((s, idx) => (
                                    <p key={idx} style={{ marginLeft: '15px' }}>- ID: {s.sensor_id}, Nama: {s.nama_sensor}</p>
                                ))}
                                {!req.sensors || !Array.isArray(req.sensors) || req.sensors.filter(s => s.is_main).length === 0 ? (
                                    <p style={{ marginLeft: '15px' }}>- Tidak ada informasi sensor utama yang valid.</p>
                                ) : null}

                                <h4>Sensor Opsional:</h4>
                                {req.sensors && Array.isArray(req.sensors) && req.sensors.filter(s => !s.is_main).length > 0 ? (
                                    req.sensors.filter(s => !s.is_main).map((s, idx) => (
                                        <p key={idx} style={{ marginLeft: '15px' }}>- ID: {s.sensor_id}, Nama: {s.nama_sensor}</p>
                                    ))
                                ) : (
                                    <p style={{ marginLeft: '15px' }}>- Tidak ada sensor opsional.</p>
                                )}

                                <p><strong>Diminta pada:</strong> {new Date(req.requested_at).toLocaleString()}</p>
                                <div className="actions">
                                    <button onClick={() => handleApprove(req.id)} disabled={loading}>Setujui</button>
                                    <button onClick={() => handleReject(req.id)} disabled={loading}>Tolak</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            )}
        </div>
    );
};

export default SuperAdminRegister;